import { render, staticRenderFns } from "./SavedSearchesWidget.vue?vue&type=template&id=5ce2bde9&scoped=true&"
import script from "./SavedSearchesWidget.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SavedSearchesWidget.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce2bde9",
  null
  
)

export default component.exports